import { registerTab } from "lib/@components/tabs"
import { ScenariosTab } from "./scenarios-tab"

registerTab({
    tab: "optimiser",
    id: "scenarios",
    title: "Scenarios",
    content: <ScenariosTab $lazy priority={10} />,
})
